/**
 * findurdealz.com — Global Store Interactivity & Shopify AJAX Cart
 */

// Clean up any legacy localStorage mock cart that could flash stale counts
try {
  localStorage.removeItem('findurdealz_cart');
} catch (e) {}

// Global Toast Notifications
function showToast(message) {
  const container = document.getElementById('toast-container');
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>${message}</span>
  `;
  container.appendChild(toast);

  // Trigger animation
  setTimeout(() => toast.classList.add('show'), 10);

  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 3200);
}

// Update DOM cart counters immediately
function applyCartCount(count) {
  const validCount = typeof count === 'number' && !isNaN(count) && count >= 0 ? count : 0;
  const desktopBadge = document.getElementById('cart-badge-count');
  const mobileBadge = document.getElementById('mobile-cart-badge-count');
  const allCounters = document.querySelectorAll('.cart-counter');

  if (desktopBadge) {
    if (validCount > 0) {
      desktopBadge.textContent = validCount;
      desktopBadge.style.display = 'inline-flex';
    } else {
      desktopBadge.textContent = '0';
      desktopBadge.style.display = 'none';
    }
  }

  if (mobileBadge) {
    mobileBadge.textContent = validCount > 0 ? `(${validCount})` : '';
  }

  allCounters.forEach(counter => {
    if (counter !== desktopBadge) {
      if (validCount > 0) {
        counter.textContent = validCount;
        counter.style.display = 'inline-flex';
      } else {
        counter.textContent = '0';
        counter.style.display = 'none';
      }
    }
  });
}

// Fetch live cart state from Shopify backend
function syncShopifyCart(callback) {
  fetch('/cart.js?_t=' + Date.now(), {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' },
    cache: 'no-store'
  })
    .then(res => res.json())
    .then(cart => {
      const count = typeof cart.item_count === 'number' ? cart.item_count : 0;
      try {
        sessionStorage.setItem('shopify_cart_count', count);
      } catch (e) {}
      applyCartCount(count);
      if (typeof callback === 'function') {
        callback(cart);
      }
    })
    .catch(err => {
      console.warn('Shopify cart sync warning:', err);
    });
}

// AJAX Add to Cart handler
function shopifyAddToCart(options) {
  const rawId = options.variantId;
  const variantId = rawId ? Number(rawId) : null;
  const quantity = parseInt(options.quantity, 10) || 1;
  const buttonEl = options.buttonEl;
  const productTitle = options.productTitle || 'Product';
  const productUrl = options.productUrl;

  if (!variantId || isNaN(variantId) || variantId <= 0) {
    if (productUrl) {
      window.location.href = productUrl;
      return;
    }
    showToast('Please select options on the product page.');
    return;
  }

  let originalHTML = '';
  if (buttonEl) {
    originalHTML = buttonEl.innerHTML;
    buttonEl.disabled = true;
    buttonEl.innerHTML = '<span class="btn-spinner"></span> ADDING...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: quantity
    })
  })
    .then(res => {
      if (!res.ok) {
        return res.json().then(errData => {
          throw new Error(errData.description || errData.message || 'Could not add product to bag.');
        });
      }
      return res.json();
    })
    .then(item => {
      if (buttonEl) {
        buttonEl.innerHTML = 'ADDED! ✓';
        buttonEl.classList.add('added-success');
        setTimeout(() => {
          buttonEl.innerHTML = originalHTML;
          buttonEl.classList.remove('added-success');
          buttonEl.disabled = false;
        }, 1800);
      }

      const title = productTitle || item.title || item.product_title || 'Item';
      showToast(`Added "${title}" to your bag! 🛍️`);

      // Broadcast cart refresh to header and all listeners
      syncShopifyCart();
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(err => {
      console.error('AJAX add to bag failed:', err);
      if (buttonEl) {
        buttonEl.innerHTML = originalHTML;
        buttonEl.disabled = false;
      }
      // If variant was not found on Shopify, redirect user to the product page to choose variant
      if (err.message && err.message.toLowerCase().includes('variant') && productUrl) {
        window.location.href = productUrl;
        return;
      }
      showToast(err.message || 'Unable to add item to bag.');
    });
}

// Fallback addToCart function for mockup / demo cards without Shopify variants
function addToCart(product, qty = 1, buttonEl = null) {
  if (product && !isNaN(product.id) && Number(product.id) > 1000) {
    shopifyAddToCart({
      variantId: product.id,
      quantity: qty,
      buttonEl: buttonEl,
      productTitle: product.title
    });
    return;
  }

  // Visual feedback on button
  if (buttonEl) {
    const originalHTML = buttonEl.innerHTML;
    buttonEl.disabled = true;
    buttonEl.innerHTML = 'ADDED! ✓';
    buttonEl.classList.add('added-success');
    setTimeout(() => {
      buttonEl.innerHTML = originalHTML;
      buttonEl.classList.remove('added-success');
      buttonEl.disabled = false;
    }, 1800);
  }

  // Update session count gracefully
  let currentCount = 0;
  try {
    currentCount = parseInt(sessionStorage.getItem('shopify_cart_count') || '0', 10) || 0;
  } catch (e) {}
  const newCount = currentCount + (qty || 1);
  try {
    sessionStorage.setItem('shopify_cart_count', newCount);
  } catch (e) {}
  applyCartCount(newCount);

  showToast(`Added "${product && product.title ? product.title : 'Product'}" to your bag! 🛍️`);
}

// Mobile Slide-Over Drawer Toggle
function toggleMobileNav(open) {
  const drawer = document.getElementById('mobile-nav-drawer');
  const backdrop = document.getElementById('mobile-nav-backdrop');
  if (drawer && backdrop) {
    if (open) {
      drawer.classList.add('open');
      backdrop.classList.add('open');
      document.body.style.overflow = 'hidden';
    } else {
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      document.body.style.overflow = '';
    }
  }
}

// Intercept form submissions across the theme for seamless AJAX Add to Bag
document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form || !form.matches) return;

  const isCartAddForm =
    form.matches('form[action*="/cart/add"]') ||
    form.classList.contains('product-card-form') ||
    form.id === 'add-to-cart-form';

  if (isCartAddForm) {
    // Check if checkout button was clicked instead of add to bag
    const submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') {
      return; // allow standard checkout submit
    }

    e.preventDefault();
    e.stopPropagation();

    const submitBtn = submitter || form.querySelector('button[type="submit"], .product-add-btn, .btn-add-to-cart');
    const variantInput = form.querySelector('input[name="id"], select[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');

    const variantId = variantInput ? variantInput.value : (submitBtn ? submitBtn.getAttribute('data-variant-id') : null);
    const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    const title = (submitBtn && submitBtn.getAttribute('data-product-title')) ||
                  document.querySelector('.product-single-title')?.textContent?.trim() || '';
    const productUrl = (submitBtn && submitBtn.getAttribute('data-product-url')) ||
                       form.closest('.product-card')?.querySelector('.product-img-link')?.getAttribute('href') || null;

    if (variantId && !isNaN(Number(variantId)) && Number(variantId) > 0) {
      shopifyAddToCart({
        variantId: variantId,
        quantity: quantity,
        buttonEl: submitBtn,
        productTitle: title,
        productUrl: productUrl
      });
    } else if (productUrl) {
      window.location.href = productUrl;
    } else {
      showToast('Please select options on the product page.');
    }
  }
}, true);

// Global click delegation for any non-submit Add to Bag buttons
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.product-add-btn, .btn-add-to-cart');
  if (!btn) return;

  // Let submit event handler deal with buttons inside forms
  const form = btn.closest('form');
  if (btn.type === 'submit' && form) {
    return;
  }

  // Prevent default navigation
  e.preventDefault();

  const variantId = btn.getAttribute('data-variant-id') || (form ? form.querySelector('input[name="id"]')?.value : null);
  const qtyInput = document.getElementById('detail-qty-input') || (form ? form.querySelector('input[name="quantity"]') : null);
  const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  const title = btn.getAttribute('data-product-title') ||
                document.querySelector('.product-single-title')?.textContent?.trim() || '';
  const productUrl = btn.getAttribute('data-product-url') ||
                     btn.closest('.product-card')?.querySelector('.product-img-link')?.getAttribute('href') || null;

  if (variantId && !isNaN(Number(variantId)) && Number(variantId) > 0) {
    shopifyAddToCart({
      variantId: variantId,
      quantity: quantity,
      buttonEl: btn,
      productTitle: title,
      productUrl: productUrl
    });
  } else if (productUrl) {
    window.location.href = productUrl;
  }
});

// Global cart item update handler for cart page
window.updateCartQty = function(key, quantity) {
  var newQty = parseInt(quantity, 10);
  if (isNaN(newQty) || newQty < 0) newQty = 0;

  var cartLayout = document.querySelector('.cart-layout');
  if (cartLayout) {
    cartLayout.style.opacity = '0.5';
    cartLayout.style.pointerEvents = 'none';
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: String(key),
      quantity: newQty
    })
  })
  .then(function(res) {
    if (!res.ok) {
      throw new Error('Could not update cart quantity');
    }
    return res.json();
  })
  .then(function(cart) {
    try {
      sessionStorage.setItem('shopify_cart_count', cart.item_count || 0);
    } catch (e) {}
    window.location.reload();
  })
  .catch(function(err) {
    console.error('Cart update error:', err);
    window.location.reload();
  });
};

// Fast initialization
(function initCartBadge() {
  // 1. Immediately read cached session count to eliminate any flash of stale numbers
  try {
    const cached = sessionStorage.getItem('shopify_cart_count');
    if (cached !== null && cached !== '') {
      const num = parseInt(cached, 10);
      if (!isNaN(num)) {
        applyCartCount(num);
      }
    }
  } catch (e) {}

  // 2. Fetch fresh cart from server in background
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncShopifyCart());
  } else {
    syncShopifyCart();
  }

  window.addEventListener('pageshow', () => syncShopifyCart());
  window.addEventListener('cart:refresh', () => syncShopifyCart());
})();
